import { ErrorHandler, inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ObservableInput, of } from 'rxjs';
import { trace } from '@opentelemetry/api';
import { OpenTelemetryService } from './opentelemetry.service';
import { ERoute } from '../../constants/routes.enum';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService implements ErrorHandler {
  private readonly router: Router = inject(Router);

  private readonly _errors: string[] = [];

  constructor(private readonly otelService: OpenTelemetryService) {}

  handleError(error: any): void {
    console.error('Global Error Caught:', error);

    if (error instanceof Error) {
      this.otelService.logError(error);
    } else {
      this.otelService.logError(new Error(String(error)));
    }
  }

  handle<T>(err: HttpErrorResponse, defaultEntity: T): ObservableInput<T> {
    if ((err.status + '').trim().startsWith('5')) {
      this.handleFatal(err.message);
    } else if ((err.status + '').trim().startsWith('4')) {
      this.handleWarning(err.message);
    } else {
      trace.getActiveSpan()?.recordException(err);
    }
    return of(defaultEntity);
  }

  handleFatal(message: string, extra?: unknown) {
    console.error('Fatal Error Caught:', message, extra);
    if (extra) {
      trace.getActiveSpan()?.recordException(message);
    } else {
      trace.getActiveSpan()?.recordException(message);
    }

    this._errors.push(message);
    this.router.navigate([`/${ERoute.error}`]);
  }

  handleWarning(message: string) {
    console.warn(message);
  }

  get errors() {
    return this._errors;
  }
}
